import * as React from 'react';
// var ReactDom = require('react-dom');
import { Theme } from '@material-ui/core/styles';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { IconButton } from '@material-ui/core'
import { Typography } from '@material-ui/core';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CenterFocusWeak from '@material-ui/icons/CenterFocusWeak';
import RotateLeft from '@material-ui/icons/RotateLeft';
import RotateRight from '@material-ui/icons/RotateRight';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { each } from 'lodash'
import { Tooltip } from '@material-ui/core';
import { Hidden } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';


var keyMap = {
  "ctrl+alt+j": {
    key: "j",
    action: "scaleFitWidth",
    description: "Fit Width"
  },
  "ctrl+alt+h": {
    key: "h",
    action: "panLeft",
    description: "Pan Left"
  },
  "ctrl+alt+k": {
    key: "k",
    action: "panRight",
    description: "Pan Right"
  },
  "ctrl+alt+u": {
    key: "u",
    action: "panUp",
    description: "Pan Up"
  },
  "ctrl+alt+m": {
    key: "m",
    action: "panDown",
    description: "Pan Down"
  },
  "ctrl+alt+y": {
    key: "y",
    action: "zoomUpperLeft",
    description: "Zoom Upper Left"
  },
  "ctrl+alt+i": {
    key: "i",
    action: "zoomUpperRight",
    description: "Zoom Upper Right"
  },
  "ctrl+alt+.": {
    key: ".",
    action: "zoomLowerRight",
    description: "Zoom Lower Right"
  },
  "ctrl+alt+,": {
    key: ",",
    action: "zoomLowerLeft",
    description: "Zoom Lower Left"
  },

  "ctrl+alt+=": {
    key: "=",
    action: "zoomIn",
    description: "Zoom In"
  },
  "ctrl+alt+-": {
    key: "-",
    action: "zoomOut",
    description: "Zoom Out"
  }
};

var SHIFT_PCT = 0.125;

type State = {
  image?: any;
  rotation: number;
  scale: number;
  offsetX: number;
  offsetY: number;
};

const styles = (theme: Theme): StyleRules => ({
  imageWell: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    // minHeight: "300px",
    marginTop: "5px",
    height: "100%"
  },
  svgContainer: {
    width: "100%",
    height: "100%",
    minHeight: 600,
    cursor: "pointer",
    overflow: "hidden"
  },
  control: {
    margin: 1
  },
  controlContainer: {
    display: 'inline-block'
  },
  pageCountContainer: {
    textAlign: 'center',
  },
  message: {
    display: "flex",
    justifyContent: "center",
    paddingTop: 50
  },
  messageLink: {
    paddingLeft: 15
  }
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  url: string;
  firstPage?: () => void;
  previousPage?: () => void;
  nextPage?: () => void;
  lastPage?: () => void;
  export?: () => void;
  classes: any;
  rotation: number;
  objectData?: any;
  keyBinder?: any;
  currentPage?: number;
  pageCount?: number;
  onRotateDataChange?: (rotation: number) => void;
  rotateData?: number;
  onDelete?: () => void;
}

class ImageViewer extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  dragData: any;
  constructor(props: Props) {
    super(props, {});
    this.state = {
      rotation: props.rotation || 0,
      scale: 1,
      offsetX: 0,
      offsetY: 0
    }
  }

  componentDidMount() {
    var self = this
    this._loadImage(this.props.url)
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      imageWell.addEventListener("wheel", (e: any) => {
        e.preventDefault()

        var bf = self.getScaleBestFit(1)

        var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail))
        var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail))
        if (delta > 0) {
          var scale = self.state.scale + .02;
          self.setState({ scale: scale });
        } else if (delta < 0) {
          var scale = self.state.scale - .02;
          if (bf) {
            if (scale > bf.scale) {
              self.setState({ scale: scale });
            }
          }
        }
      })
      //window.addEventListener("resize", debounce(this.scaleFitWidth))
    }
    if (this.props.keyBinder) {
      each(keyMap, (entry: any, combo: any) => {
        this.props.keyBinder.bind(combo, function () {
          self.performAction(entry.action);
        });
      })
    }
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", debounce(this.scaleFitWidth))
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.objectData) {
      if (this.isNative(nextProps.objectData.contentType.value)) {
        this._loadImage(nextProps.url, nextProps.rotateData)
      }
    } else {
      this._loadImage(nextProps.url, nextProps.rotateData)
    }
  }

  // componentWillUnmount() {
  //   this.props.keyBinder.reset()
  // }

  performAction = (action: any) => {
    console.log("performAction", action)
    if (action) {
      if (this[action]) {
        this[action].apply(this, []);
      }
    }
  }

  isNative = (contentType: string): boolean => {
    if (contentType == "image/tiff" || contentType == "application/pdf" || contentType == "image/png" || contentType == "image/jpeg") {
      return true
    }
    return false
  }

  render() {
    const { classes }: { classes: ClassNameMap; } = this.props;
    const { objectData, currentPage, pageCount } = this.props
    const { image } = this.state

    var url = ""
    if (image) {
      url = image.url
    } else {
      url = this.props.url
    }

    var transformData = this._calculateTransformData();

    var disabled = this.state.image ? false : true

    var imageContainer
    if (image) {
      imageContainer = (
        <svg className={classes.svgContainer}>
          <image
            xlinkHref={url}
            width={image.width}
            height={image.height}
            transform={transformData.transform}
            onDoubleClick={this.getScaleBestFit}
            onMouseDown={this._mouseDown}
            onMouseMove={this._mouseMove}
            onMouseUp={this._mouseUp}
            onMouseLeave={this._mouseLeave}
          >
          </image>
        </svg>
      )

    } else {
      imageContainer = (<div />)
    }

    if (objectData) {
      if (!this.isNative(objectData.contentType.value)) {
        imageContainer = (
          <Typography variant="body2" className={classes.message}>This document is not natively viewable in the browser, to view this document<a className={classes.messageLink} style={{ cursor: "pointer", color: "#337ab7" }} onClick={this._export}>Click here</a></Typography>
        )
      }
    }

    return (
      <div className={classes.container}>
        <div className={classes.controls}>
          {this.props.export && <Hidden only={['xs']}>
            <Tooltip enterDelay={200} id="tooltip-top-start1" placement="top-start" title="Download Document">
              <div className={classes.controlContainer}>
                <IconButton tabIndex={-1} disabled={disabled} onClick={this._export} disableRipple={true} color="default" className={classes.control}>
                  <CloudDownload />
                </IconButton>
              </div>
            </Tooltip>
          </Hidden>}
          <Tooltip enterDelay={200} id="2" placement="top" title="Zoom In">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.zoomIn} disableRipple={true} color="default" className={classes.control}>
                <ZoomIn />
              </IconButton>
            </div>
          </Tooltip>
          <Tooltip enterDelay={200} title="Zoom Out">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.zoomOut} disableRipple={true} color="default" className={classes.control}>
                <ZoomOut />
              </IconButton>
            </div>
          </Tooltip>
          <Tooltip enterDelay={200} title="Fit To Screen">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.scaleBestFit.bind(this, 1)} disableRipple={true} color="default" className={classes.control}>
                <CenterFocusWeak />
              </IconButton>
            </div>
          </Tooltip>
          <Tooltip enterDelay={200} title="Rotate Left">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.rotateCounterClockwise} disableRipple={true} color="default" className={classes.control}>
                <RotateLeft />
              </IconButton>
            </div>
          </Tooltip>
          <Tooltip enterDelay={200} title="Rotate Right">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.rotateClockwise} disableRipple={true} color="default" className={classes.control}>
                <RotateRight />
              </IconButton>
            </div>
          </Tooltip>
          {this.props.onDelete && <Tooltip enterDelay={200} title="Delete">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} onClick={this.props.onDelete} disableRipple={true} color="default" className={classes.control}>
                <DeleteIcon />
              </IconButton>
            </div>
          </Tooltip>}
        </div>
        <div id="imageWell" style={{ overflow: 'hidden', minHeight: 400, height: window.innerHeight - 280 }} ref="imageWell" className={classes.imageWell}>

          {imageContainer}

        </div>
        <div className={classes.pageCountContainer}>
          {this.props.firstPage && <Tooltip enterDelay={200} title="First Page">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.firstPage} disableRipple={true} color="default" className={classes.control}>
                <FirstPage />
              </IconButton>
            </div>
          </Tooltip>}
          {this.props.previousPage && <Tooltip enterDelay={200} title="Previous Page">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.previousPage} disableRipple={true} color="default" className={classes.control}>
                <ChevronLeft />
              </IconButton>
            </div>
          </Tooltip>}
          {currentPage && pageCount &&
            <span className={classes.controlContainer}>
              Page {currentPage} of {pageCount}
            </span>
          }
          {this.props.nextPage && <Tooltip enterDelay={200} title="Next Page">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.nextPage} disableRipple={true} color="default" className={classes.control}>
                <ChevronRight />
              </IconButton>
            </div>
          </Tooltip>}
          {this.props.lastPage && <Tooltip enterDelay={200} title="Last Page">
            <div className={classes.controlContainer}>
              <IconButton tabIndex={-1} disabled={disabled} onClick={this.lastPage} disableRipple={true} color="default" className={classes.control}>
                <LastPage />
              </IconButton>
            </div>
          </Tooltip>}
        </div>
      </div>
    )
  }


  _getViewportRelativeCenter = () => {
    const imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      var scale = this.state.scale;
      var scaleWidth = this.state.image.width * scale;
      var scaleHeight = this.state.image.height * scale;
      var viewportScaleHeight = svgRect.height * (1 / scale);
      var viewportScaleWidth = svgRect.width * (1 / scale);
      var transOffsetX = this.state.offsetX || 0;
      var transOffsetY = this.state.offsetY || 0;

      var centerX = viewportScaleWidth / 2 + transOffsetX;
      var centerY = viewportScaleHeight / 2 + transOffsetY;

      if (scaleWidth > svgRect.width) {
        centerX = viewportScaleWidth / 2 + transOffsetX;
      }

      if (scaleHeight > svgRect.height) {
        centerY = viewportScaleHeight / 2 + transOffsetY;
      }
      return {
        x: centerX,
        y: centerY
      };
    }
    return null
  }

  _calculateTransformData = () => {
    const imageWell = document.getElementById("imageWell")
    var transform = "";
    var center;
    var transOffsetX = this.state.offsetX || 0;
    var transOffsetY = this.state.offsetY || 0;

    if (this.state.scale !== 1) {
      transform += 'scale(' + this.state.scale + ') ';
    }

    if (imageWell && this.state.image) {

      if (this.state.rotation !== 0) {
        center = this._getViewportRelativeCenter();
        if (center) {
          //Determine the center of the viewport relative to the image.
          transform += 'rotate(' + this.state.rotation + ' ' + center.x + ' ' + center.y + ') ';
        }
      }
    }

    transform += 'translate(' + transOffsetX + ' ' + transOffsetY + ')';

    return {
      transform: transform
    };
  }

  _loadImage = (url: string, rotation?: number) => {
    if (!rotation) {
      rotation = 0
    }
    var self = this;

    if (url) {
      var currentURL: string = (this.state.image || {}).url;
      if (currentURL != url) {
        var img = new Image();
        img.onload = function () {
          self.setState({
            rotation: rotation || 0, image: {
              url: url,
              width: img.width,
              height: img.height,
              rotation: rotation
            }
          }, function () {
            self.scaleFitWidth();
          });
        };
        self.setState({
          // rotation: rotation
        }, () => {
          img.src = url;
        })
      }
    } else {
      self.setState({
        image: undefined,
        url: "",
      })
    }
  }

  _mouseDown = (evt: any) => {
    this.dragData = {
      origMouseX: evt.clientX,
      origMouseY: evt.clientY,
      origOffsetX: this.state.offsetX,
      origOffsetY: this.state.offsetY
    };
  }

  _mouseMove = (evt: any) => {
    if (this.dragData) {
      var newOffsetX = this.dragData.origOffsetX + (evt.clientX - this.dragData.origMouseX) * (1 / this.state.scale / 2);
      var newOffsetY = this.dragData.origOffsetY + (evt.clientY - this.dragData.origMouseY) * (1 / this.state.scale / 2);
      this.setState({ offsetX: newOffsetX, offsetY: newOffsetY });
    }
  }

  _mouseUp = (evt: any) => {
    delete this.dragData;
  }

  _mouseLeave = () => {
    delete this.dragData;
  }

  scaleBestFit = (scaleFactor: any | undefined) => {
    if (scaleFactor) {
      var stateUpdate = this.getScaleBestFit(scaleFactor)
      if (stateUpdate) {
        this.setState(stateUpdate);
      }
    }
  }

  getScaleBestFit = (scaleFactor: any) => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect()
      var hScale = svgRect.width / (this.state.image || { width: 1 }).width;
      var vScale = svgRect.height / (this.state.image || { height: 1 }).height;
      var scale;
      var scaleWidth;
      var scaleHeight;
      var offsetX = 0;
      var offsetY = 0;

      scaleFactor = scaleFactor || 1;
      if (vScale > hScale) {
        scale = hScale * scaleFactor;
        scaleWidth = scale * svgRect.width;
        scaleHeight = scale * svgRect.height;
        if (scaleHeight < svgRect.height) {
          offsetY = (svgRect.height - scaleHeight) / 2;
          offsetX = 0;
        }
      } else {
        scale = vScale * scaleFactor;
        scaleWidth = scale * svgRect.width;
        scaleHeight = scale * svgRect.height;
        if (scaleWidth < svgRect.width) {
          offsetX = (svgRect.width - scaleWidth) / 2;
          offsetY = 0;
        }
      }

      return { scale: scale, offsetX: offsetX, offsetY: offsetY }
    }
    return null
  }

  scaleFitWidth = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect()
      var scale = svgRect.width / this.state.image.width;
      var scaleHeight = this.state.image.height * scale;
      var offsetY = 0;
      if (scaleHeight < svgRect.height) {
        // This image when scaled to fit width is shorter than the view box
        // Let's center the image vertically
        offsetY = (svgRect.height - scaleHeight) / 2;
      }
      this.setState({ scale: scale, offsetY: offsetY, offsetX: 0 });
    }
  }

  scaleFitHeight = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      var scale = svgRect.height / this.state.image.height;

      var offsetX = this.state.offsetX || 0;

      this.setState({ scale: scale, offsetX: offsetX });
    }
  }

  fitToPage = () => {
    this.scaleFitWidth()
    this.scaleFitHeight()
  }

  zoomUpperLeft = () => {
    this.scaleBestFit(2);
    this.setState({
      offsetX: 0,
      offsetY: 0
    });
  }

  zoomUpperRight = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      this.scaleBestFit(2);
      this.setState({
        offsetX: -((this.state.image.width - svgRect.width) * this.state.scale - svgRect.width * this.state.scale),
        offsetY: 0
      });
    }
  }

  zoomLowerLeft = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect()
      this.scaleBestFit(2);
      this.setState({
        offsetX: 0,
        offsetY: -((this.state.image.height - svgRect.height) * this.state.scale - svgRect.height * this.state.scale)
      });
    }
  }

  zoomLowerRight = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      this.scaleBestFit(2);
      this.setState({
        offsetX: -((this.state.image.width - svgRect.width) * this.state.scale - svgRect.width * this.state.scale),
        offsetY: -((this.state.image.height - svgRect.height) * this.state.scale - svgRect.height * this.state.scale)
      });
    }
  }

  zoomIn = () => {
    var scale = this.state.scale * 1.25;
    this.setState({ scale: scale });
  }

  zoomOut = () => {
    var scale = this.state.scale * 0.80;
    this.setState({ scale: scale });
  }

  roll = () => {
    this._loadImage("https://media2.giphy.com/media/5kq0GCjHA8Rwc/200.gif");
  }

  rotateClockwise = () => {
    var rotation = this.state.rotation;
    if (rotation !== 270) {
      rotation += 90;
    } else {
      rotation = 0;
    }
    this.setState({ rotation: rotation }, () => {
      if (this.props.onRotateDataChange) {
        this.props.onRotateDataChange(rotation)
      }
    });
  }

  rotateCounterClockwise = () => {
    var rotation = this.state.rotation;

    if (rotation !== 0) {
      rotation += -90;
    } else {
      rotation = 270;
    }
    this.setState({ rotation: rotation }, () => {
      if (this.props.onRotateDataChange) {
        this.props.onRotateDataChange(rotation)
      }
    });
  }

  panLeft = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      var scale = this.state.scale;
      var scaleWidth = this.state.image.width * scale;
      if (scaleWidth > svgRect.width) {
        var offsetX = this.state.offsetX - this.state.image.width / 2 * SHIFT_PCT;
        this.setState({ offsetX: offsetX });
      }
    }
  }

  panRight = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      var scale = this.state.scale;
      var scaleWidth = this.state.image.width * scale;
      if (scaleWidth > svgRect.width) {
        var offsetX = this.state.offsetX + this.state.image.width / 2 * SHIFT_PCT;
        this.setState({ offsetX: offsetX });
      }
    }
  }

  panUp = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      var scale = this.state.scale;
      var scaleHeight = this.state.image.height * scale;
      if (scaleHeight > svgRect.height) {
        var offsetY = this.state.offsetY - this.state.image.height / 2 * SHIFT_PCT;
        this.setState({ offsetY: offsetY });
      }
    }
  }

  panDown = () => {
    var imageWell = document.getElementById("imageWell")
    if (imageWell) {
      var svgRect = imageWell.getBoundingClientRect();
      var scale = this.state.scale;
      var scaleHeight = this.state.image.height * scale;
      if (scaleHeight > svgRect.height) {
        var offsetY = this.state.offsetY + this.state.image.height / 2 * SHIFT_PCT;
        this.setState({ offsetY: offsetY });
      }
    }
  }

  /*
    Externally managed user functions
  */
  firstPage = () => {
    if (this.props.firstPage) {
      this.props.firstPage()
    }
  }

  previousPage = () => {
    if (this.props.previousPage) {
      this.props.previousPage()
    }
  }

  nextPage = () => {
    if (this.props.nextPage) {
      this.props.nextPage()
    }
  }

  lastPage = () => {
    if (this.props.lastPage) {
      this.props.lastPage()
    }
  }

  _export = () => {
    if (this.props.export) {
      this.props.export()
    }
  }
}

export default withStyles(styles)(ImageViewer);
